/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Actions that can be taken on a push notification challenge.
 */
export enum MFAAction {
    APPROVE = 'approve',
    REJECT = 'reject',
}
